import {useSelector, useDispatch} from 'react-redux';
import {
  selectPaymentData,
  selectSelectedBanData,
  selectPaymentAction,
  selectGroupedBans,
  selectSelectedPaymentType,
  handleCurrentStep,
  clearHistory,
} from '../DebtAndUpdatePaymentBlockSlice';

export const useDebtPaymentResult = () => {
  const dispatch = useDispatch();
  const paymentData = useSelector(selectPaymentData);
  const selectedBanData = useSelector(selectSelectedBanData);
  const paymentActionType = useSelector(selectPaymentAction);
  // Determine if there are other bans with debt (excluding the currently selected one)
  const financialIssuesBans = useSelector(selectGroupedBans)?.FINANCIAL_ISSUES || [];
  const hasOtherBansWithDebt = financialIssuesBans.some(
    (ban) =>
      ban.banNumber !== selectedBanData?.banNumber && // Exclude selected ban
      ban.hasDebt, // Has debt
  );

  const selectedPaymentType = useSelector(selectSelectedPaymentType);
  const phoneNumber = useSelector((s) => s.authentication.loginData?.userDetails?.contactNumber);
  const actions = {
    goToStep: (step) => dispatch(handleCurrentStep(step)),
    clearHistory: () => dispatch(clearHistory()),
  };

  return {
    paymentData: {...paymentData, phoneNumber},
    selectedBanData,
    paymentActionType,
    hasOtherBansWithDebt,
    selectedPaymentType,
    actions,
  };
};
